import { defineStore } from 'pinia'
import type { RouteLocationRaw } from 'vue-router'

export const useRedirectStore = defineStore('redirect', {
  state: () => ({
    redirectTo: null as RouteLocationRaw | null,
  }),

  actions: {
    setRedirect(route: RouteLocationRaw) {
      this.redirectTo = route
    },

    clear() {
      this.redirectTo = null
    },
  },
})
